<ion-content style="border-top:4px solid #0100ee;" min="0" max="2400" color="white" class="ion-padding profile">
  <!--div class="ion-padding profile__picture">
    img [src]="service?.avatar?.document?.fileName | ppImage">
  </div-->

  <ion-button fill="clear" style="margin-right:0px;" class="ion-float-right" (click)="onCancel()">
    <ion-icon name="close" mode="md"></ion-icon>
  </ion-button>

  <div *ngIf="noShowProtection">

    <h2>{{ 'PAYMENT_INFO.NO_SHOW.TITLE' | translate }}</h2>

    <p>{{ 'PAYMENT_INFO.NO_SHOW.1_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.2_PARAG' | translate : { noShowMaxPenaltyPerPerson: maxAmountPerPerson } }}</p>
    <h5 style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.NO_SHOW.CANCELATION_TITLE' | translate }}</h5>
    <p style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.NO_SHOW.3_PARAG' | translate : { cancellationPeriodInHours: cancellationPeriodInHours } }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.4_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.5_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.6_PARAG' | translate }}</p>

  </div>

  <div *ngIf="fullPaymentProtection">

    <h2>{{ 'PAYMENT_INFO.PAYMENT.TITLE' | translate }}</h2>

    <p>{{ 'PAYMENT_INFO.PAYMENT.1_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.PAYMENT.2_PARAG' | translate : { maxAmountPerPerson: maxAmountPerPerson } }}</p>
    <h5 style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.PAYMENT.CANCELATION_TITLE' | translate }}</h5>
    <p style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.PAYMENT.3_PARAG' | translate : { cancellationPeriodInHours: cancellationPeriodInHours } }}</p>
    <p>{{ 'PAYMENT_INFO.PAYMENT.4_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.PAYMENT.5_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.PAYMENT.6_PARAG' | translate }}</p>

  </div>

  <div *ngIf="minSpendPaymentProtection">

    <h2>MIN SPEND - {{ minSpendAmountPerPerson }} - {{ 'PAYMENT_INFO.NO_SHOW.TITLE' | translate }}</h2>

    <p>{{ 'PAYMENT_INFO.NO_SHOW.1_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.2_PARAG' | translate : { maxAmountPerPerson: maxAmountPerPerson } }}</p>
    <h5 style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.NO_SHOW.CANCELATION_TITLE' | translate }}</h5>
    <p style="color: #444444; font-weight: bold;">{{ 'PAYMENT_INFO.NO_SHOW.3_PARAG' | translate : { cancellationPeriodInHours: cancellationPeriodInHours } }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.4_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.5_PARAG' | translate }}</p>
    <p>{{ 'PAYMENT_INFO.NO_SHOW.6_PARAG' | translate }}</p>

  </div>


  <div class="ion-float-left clickable" style="margin-top:36px;">
    <a (click)="onCancel()"  class="pp-link">{{ 'EMPLOYEE_MODAL.CLOSE' | translate }}</a>
  </div>

</ion-content>
